var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  evaluateExpressionError: () => evaluateExpressionError,
  scopeWithMissingSymbols: () => scopeWithMissingSymbols
});
var import_constants = __toModule(require("../../../../engine/constants"));
var import_core = __toModule(require("../../../../engine/math/core"));
var import_utils = __toModule(require("../../../../engine/utils"));
var import_mathEvaluateError = __toModule(require("../../../../error/mathEvaluateError"));
function findSymbols(expression, regexp) {
  const expressionSymbols = expression.match(regexp);
  if (expressionSymbols === null) {
    return [];
  }
  return expressionSymbols;
}
const scopeWithMissingSymbolsInExpression = (scope, expression) => {
  if (typeof scope !== "object" || scope === null) {
    throw new import_mathEvaluateError.MathEvaluateError(`Invalid scope: ${scope} for expression: ${expression}`);
  }
  const expressionSymbols = findSymbols(expression, import_utils.SYMBOL_REGEX);
  const newScope = {};
  for (const symbol of expressionSymbols) {
    newScope[symbol] = scope[symbol];
  }
  return newScope;
};
const scopeWithMissingSymbols = (scope, expression) => {
  const newScope = scopeWithMissingSymbolsInExpression(scope, expression);
  if (scope[import_constants.SCOPE_ORIGINAL]) {
    const originalScope = scopeWithMissingSymbolsInExpression(scope[import_constants.SCOPE_ORIGINAL], expression);
    newScope[import_constants.SCOPE_ORIGINAL] = originalScope;
  }
  return newScope;
};
const evaluateExpressionError = (err, expression, evaluationId) => {
  const parser = (0, import_core.taxdownMathParser)();
  const expressionParams = (0, import_utils.findAllParamsExpression)(expression);
  let errorExpression = "";
  for (let i = 0; i < expressionParams.length; i += 1) {
    const value = parser.get(expressionParams[i]);
    if (value !== void 0) {
      if (Array.isArray(value)) {
        errorExpression = expression.split(expressionParams[i]).join(`[${value}]`);
      } else {
        errorExpression = expression.split(expressionParams[i]).join(` ${value} `);
      }
    }
  }
  return {
    id: evaluationId,
    error: err.toString(),
    originalExpression: expression.toString(),
    expression: errorExpression
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  evaluateExpressionError,
  scopeWithMissingSymbols
});
